// Import model
import { DataviewEntityResponse } from '../models/DataviewEntityResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { Entity } from '../models/Entity';
import { FilterEntityRequest } from '../models/FilterEntityRequest';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { EntitySerializer } from './EntitySerializer';
import { FilterEntityRequestSerializer } from './FilterEntityRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewEntityResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewEntityResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewEntityResponse instance
   */
  static deserialize(json: string): DataviewEntityResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewEntityResponse instance
   */
  static fromObject(obj: any): DataviewEntityResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewEntityResponse');
    }


    const instance: DataviewEntityResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        EntitySerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterEntityRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewEntityResponse instances
   */
  static deserializeArray(json: string): DataviewEntityResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewEntityResponse instance to a JSON string
   */
  static serialize(instance: DataviewEntityResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewEntityResponse instance to a plain object
   */
  static toObject(instance: DataviewEntityResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        EntitySerializer.toObject(item)
      ),
      'Request': instance.request ? FilterEntityRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewEntityResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewEntityResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
